
<iframe allowfullscreen
        data-testid="appStatisticsChart"
        frameborder="0"
        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        src="https://lookerstudio.google.com/embed/reporting/f78c1f6a-7ff5-4fd6-a843-b7e53af40106/page/p_banb9j1aqd"
        style="border:0; width: 100%;height: 100%"></iframe>
@if (!showAiAssistent()) {
  <div style="position: absolute;bottom:40px; right: 60px">
    <button class="primary-button" style="background:black;box-shadow: 0 4px 15px rgba(106, 106, 248, 0.4) "
            (click)="showAiAssistent.set(true)">

      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.0002 6L7.3335 5L10.0002 3.999L11.0002 1.33334L12.0011 3.999L14.6668 5L12.0011 6L11.0002 8.66666L10.0002 6ZM4.66681 11.3333L1.3335 10L4.66681 8.66666L6.00015 5.33334L7.3335 8.66666L10.6668 10L7.3335 11.3333L6.00015 14.6667L4.66681 11.3333Z"
          fill="white"/>
      </svg>


      {{ showAiAssistent() ? 'Close' : 'Ask AI' }}
    </button>
  </div>
}

@if (showAiAssistent()) {
  <div class="chat-container">
    <button class="icon-button" style="position: absolute; right: 14px;top: 8px" (click)="toggleAiAssistent()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.34035 5.98369C3.88655 5.52989 3.88655 4.79414 4.34035 4.34035C4.79414 3.88655 5.52989 3.88655 5.98369 4.34035L19.6596 18.0163C20.1134 18.4701 20.1134 19.2059 19.6597 19.6597C19.2059 20.1134 18.4701 20.1134 18.0163 19.6597L4.34035 5.98369Z"
          fill="#333333"/>
        <path
          d="M5.98377 19.6597C5.52997 20.1134 4.79422 20.1134 4.34042 19.6597C3.88663 19.2059 3.88663 18.4701 4.34042 18.0163L18.0164 4.34035C18.4702 3.88655 19.2059 3.88655 19.6597 4.34035C20.1135 4.79414 20.1135 5.52989 19.6597 5.98369L5.98377 19.6597Z"
          fill="#333333"/>
      </svg>

    </button>
    <div class="chat-messages">
      @for (message of messages; track message.text) {
        <div class="message" [ngClass]="{
      'user-message': message.author === 'user',
      'bot-message': message.author === 'bot'
    }">
          <div class="bubble">
            {{ message.text }}
          </div>
        </div>
      }


      @if (isLoading) {
        <div class="message bot-message">
          <div class="bubble typing-indicator">
            <span></span><span></span><span></span>
          </div>
        </div>
      }

    </div>

    <div class="chat-input">
      <input
        type="text"
        [value]="userInput()"
        (input)="userInput.set($any($event.target).value)"
        (keyup.enter)="sendMessage()"
        placeholder="Ask about your analytics..."
        [disabled]="isLoading"
      />
      <button class="primary-button" (click)="sendMessage()" [disabled]="isLoading">Send</button>
    </div>
  </div>
}
